function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.257 7.874h-3.796v2.844h4.437V12h-6.043V2.758h5.999v1.295H20.46v2.551h3.796v1.27zM26.206 12V2.758h2.73c.816 0 1.54.182 2.17.546.635.364 1.126.88 1.473 1.549.347.668.52 1.434.52 2.297v.464c0 .876-.175 1.646-.526 2.31a3.652 3.652 0 0 1-1.492 1.536c-.643.36-1.382.54-2.215.54h-2.66zm1.606-7.947v6.665h1.047c.842 0 1.488-.263 1.936-.787.453-.53.684-1.287.692-2.273v-.514c0-1.003-.218-1.769-.654-2.298-.436-.529-1.068-.793-1.898-.793h-1.123zM36.394 12h-1.6V2.758h1.6V12zm8.461-7.947h-2.882V12H40.38V4.053h-2.856V2.758h7.331v1.295zM9.108 1.607a1 1 0 0 1 1.414 0l.707.708a1 1 0 0 1 0 1.414l-7.822 7.823a.2.2 0 0 1-.12.057l-2.063.225a.2.2 0 0 1-.22-.22l.224-2.064a.2.2 0 0 1 .057-.12l7.823-7.822z",
  fill: "currentColor"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.623 13.9h-12v-1h12v1z",
  fill: "currentColor"
});

const SvgEdit = props => React.createElement("svg", _extends({
  viewBox: "0 0 46 16",
  fill: "none"
}, props), _ref, _ref2);

export default SvgEdit;